import React, { useState, useRef } from "react";
import { Calendar, Clock, Star, ChevronLeft, ChevronRight, ChevronDown, ChevronUp } from "lucide-react";

// --- EXPANDED BLOG DATA ---
const blogPosts = [
  {
    id: 1,
    title: "6 Ayurvedic Tips to Lower Your Blood Sugar Naturally",
    excerpt: "If you have diabetes, managing your blood sugar levels can become difficult over time. Discover ancient herbs that can help stabilize...",
    fullContent: "If you have diabetes, managing your blood sugar levels can become difficult over time. Discover ancient herbs that can help stabilize your levels. Herbs like Gurmar (Gymnema Sylvestre), Karela (Bitter Gourd), and Jamun seeds have been clinically proven to support healthy glucose metabolism. Regular consumption of these, along with a balanced diet and yoga, can significantly improve your quality of life.",
    image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?q=80&w=800&auto=format&fit=crop", 
    category: "Health Tips",
    date: "Feb 25, 2026",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "The Miracle of Ashwagandha: Stress Relief & Immunity",
    excerpt: "But what if we told you there's one root that has been used for over 3,000 years to relieve stress, increase energy levels, and improve concentration?",
    fullContent: "But what if we told you there's one root that has been used for over 3,000 years to relieve stress, increase energy levels, and improve concentration? Ashwagandha is a powerful adaptogen. It helps your body manage stress by lowering cortisol levels. It's also known to boost brain function, lower blood sugar and cortisol levels, and help fight symptoms of anxiety and depression. Taking it with warm milk before bed ensures deep, restorative sleep.",
    image: "https://pahadiamrut.com/cdn/shop/articles/PA_6_Jan_Shilajit_Vs_Ashwagandha.jpg?v=1768120375&width=1024", 
    category: "Herbal Guide",
    date: "Feb 22, 2026",
    readTime: "4 min read"
  },
  {
    id: 3,
    title: "Sciatica & Joint Pain: Symptoms, Causes and Treatment",
    excerpt: "Ever heard someone say they have this weird lower back pain that extends down the hip and legs? Here is how Ayurveda treats it naturally...",
    fullContent: "Ever heard someone say they have this weird lower back pain that extends down the hip and legs? Here is how Ayurveda treats it naturally. Known as 'Gridhrasi' in Ayurveda, sciatica is primarily caused by Vata dosha aggravation. Treatments involve Panchakarma therapies like Kati Basti, along with potent herbal oils (Mahanarayan Taila) and internal medicines like Yograj Guggulu to reduce inflammation and restore mobility.",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=800&auto=format&fit=crop", 
    category: "Wellness",
    date: "Feb 18, 2026",
    readTime: "6 min read"
  }
];

// --- EXPANDED TESTIMONIAL DATA ---
const testimonials = [
  {
    id: 1,
    name: "Rohan Sharma",
    image: "https://thumbs.dreamstime.com/b/portrait-young-happy-indian-business-man-executive-looking-camera-portrait-young-happy-indian-business-man-executive-214230764.jpg",
    rating: 5,
    review: "It's really helpful and I am using it from 10 to 11 days and this helps to boost my metabolism and I feel light. Highly recommend Ayush Vatika!",
    productName: "Asthi Shudhi Telam",
    productPrice: "₹2790",
    productImg: "https://kj1bcdn.b-cdn.net/media/104808/leaves-2.jpg" 
  },
  {
    id: 2,
    name: "Dhiresh Bhattacherjee",
    image: "https://www.nanhichhayafoundation.com/wp-content/uploads/2024/01/Piyush_Bhargava.jpg",
    rating: 5,
    review: "I have ordered this for me, too much satisfied with this article and now I left pills and use this amazing product regularly. Thank you Ayush Vatika.",
    productName: "Hriday Vallabh Rasayan",
    productPrice: "₹2840",
    productImg: "https://kj1bcdn.b-cdn.net/media/104808/leaves-2.jpg" 
  },
  {
    id: 3,
    name: "Anjali Desai",
    image: "https://drananditacancersurgeon.com/wp-content/uploads/2025/06/Srinita_1_tcm100-3656043.jpg",
    rating: 5,
    review: "The glow on my face is visible just after 2 weeks of use! Completely natural and smells so pure. No harsh chemicals at all.",
    productName: "Ayushvatika Glow Face Pack",
    productPrice: "₹1200",
    productImg: "https://kj1bcdn.b-cdn.net/media/104808/leaves-2.jpg" 
  },
  {
    id: 4,
    name: "Vikram Singh",
    image: "https://img.freepik.com/free-photo/young-arab-man-with-beard-wearing-casual-blue-t-shirt-success-sign-doing-positive-gesture-with-hand-thumbs-up-smiling-happy-cheerful-expression-winner-gesture_839833-2187.jpg?semt=ais_hybrid&w=740&q=80",
    rating: 5,
    review: "I have suffered from joint stiffness for years. After applying this oil twice a day, my mobility has improved significantly. Truly a lifesaver.",
    productName: "Sandhi Poshak Rasayan",
    productPrice: "₹2530",
    productImg: "https://kj1bcdn.b-cdn.net/media/104808/leaves-2.jpg" 
  }
];

const BlogSection: React.FC = () => {
  // Refs for scrolling
  const blogScrollRef = useRef<HTMLDivElement>(null);
  const testiScrollRef = useRef<HTMLDivElement>(null); // Naya ref testimonials ke liye
  
  const [expandedPostId, setExpandedPostId] = useState<number | null>(null);

  // Scroll Functions for Blog
  const scrollLeftBlog = () => {
    if (blogScrollRef.current) blogScrollRef.current.scrollBy({ left: -380, behavior: "smooth" });
  };
  const scrollRightBlog = () => {
    if (blogScrollRef.current) blogScrollRef.current.scrollBy({ left: 380, behavior: "smooth" });
  };

  // Scroll Functions for Testimonials (Naya)
  const scrollLeftTesti = () => {
    if (testiScrollRef.current) testiScrollRef.current.scrollBy({ left: -380, behavior: "smooth" });
  };
  const scrollRightTesti = () => {
    if (testiScrollRef.current) testiScrollRef.current.scrollBy({ left: 380, behavior: "smooth" });
  };

  const toggleExpand = (id: number) => {
    setExpandedPostId(expandedPostId === id ? null : id);
  };

  return (
    <section className="bg-white py-16 px-4 sm:px-6 lg:px-8 font-sans overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        {/* ========================================= */}
        {/* 1. BLOG SECTION                           */}
        {/* ========================================= */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-10">
            <div className="text-left">
                <h2 className="text-2xl md:text-3xl font-bold text-[#2e3d2f] mb-3 uppercase tracking-wide">
                    LATEST FROM THE <span className="text-green-700">AYURVEDA BLOG</span>
                </h2>
                <p className="text-gray-600 text-sm md:text-base max-w-2xl">
                    Explore our latest articles, wellness tips, and deep dives into the world of <strong className="font-semibold text-green-800">traditional Ayurvedic healing</strong>.
                </p>
            </div>
            
            {/* Blog Arrows */}
            {/* <div className="flex gap-3 mt-6 md:mt-0">
                <button onClick={scrollLeftBlog} className="p-3 rounded-full bg-gray-50 border border-gray-200 text-gray-600 hover:bg-[#2e3d2f] hover:text-white transition-all shadow-sm">
                    <ChevronLeft className="w-6 h-6" />
                </button>
                <button onClick={scrollRightBlog} className="p-3 rounded-full bg-gray-50 border border-gray-200 text-gray-600 hover:bg-[#2e3d2f] hover:text-white transition-all shadow-sm">
                    <ChevronRight className="w-6 h-6" />
                </button>
            </div> */}
        </div>

        {/* Blog Slider Container */}
        <div ref={blogScrollRef} className="flex overflow-x-auto gap-6 pb-16 pt-2 snap-x snap-mandatory [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {blogPosts.map((post) => {
            const isExpanded = expandedPostId === post.id;
            return (
                <article key={post.id} className="bg-white rounded-[1.5rem] overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group flex flex-col min-w-[320px] md:min-w-[380px] max-w-[380px] snap-start flex-shrink-0">
                    <div className="relative h-56 overflow-hidden flex-shrink-0">
                        <div className="absolute top-4 left-4 z-10 bg-white/95 text-green-800 text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 rounded-full shadow-sm">
                            {post.category}
                        </div>
                        <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-in-out" />
                    </div>

                    <div className="p-6 sm:p-8 flex flex-col flex-grow">
                        <div className="flex items-center gap-4 text-gray-400 text-xs font-medium mb-4">
                            <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {post.date}</span>
                            <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> {post.readTime}</span>
                        </div>

                        <h3 className="text-lg font-bold text-[#2e3d2f] mb-3 leading-snug group-hover:text-green-700 transition-colors">
                            {post.title}
                        </h3>
                        
                        <div className={`text-gray-600 text-sm leading-relaxed mb-6 transition-all duration-500 overflow-hidden ${isExpanded ? 'max-h-[500px]' : 'max-h-[60px] line-clamp-3'}`}>
                            {isExpanded ? post.fullContent : post.excerpt}
                        </div>

                        <div className="mt-auto pt-4 border-t border-gray-50">
                            <button onClick={() => toggleExpand(post.id)} className="inline-flex items-center gap-2 text-green-700 font-bold text-sm uppercase tracking-wide group/link w-full focus:outline-none">
                                {isExpanded ? "Show Less" : "Continue Reading"}
                                {isExpanded ? <ChevronUp className="w-4 h-4 text-green-700" /> : <ChevronDown className="w-4 h-4 text-green-700" />}
                            </button>
                        </div>
                    </div>
                </article>
            );
          })}
        </div>


        {/* ========================================= */}
        {/* 2. TESTIMONIAL SECTION (AB SLIDER HAI)    */}
        {/* ========================================= */}
        <div className="pt-16 mt-4 border-t border-gray-200">
            
            {/* Testimonial Header with Arrows */}
            <div className="flex flex-col md:flex-row justify-between items-end mb-10">
                <div className="text-left">
                    <h2 className="text-2xl md:text-3xl font-bold text-[#2e3d2f] uppercase tracking-wide">
                        REAL PEOPLE, <span className="text-green-700">REAL STORIES</span>
                    </h2>
                    <p className="text-gray-500 mt-2 text-sm md:text-base">Trusted reviews: Why India loves AyushVatika</p>
                </div>
                
                {/* Testimonial Arrows (Ye raha wo arrow jo aapko chahiye tha!) */}
                <div className="flex gap-3 mt-6 md:mt-0">
                    <button onClick={scrollLeftTesti} className="p-3 rounded-full bg-gray-50 border border-gray-200 text-gray-600 hover:bg-[#2e3d2f] hover:text-white transition-all shadow-sm">
                        <ChevronLeft className="w-6 h-6" />
                    </button>
                    <button onClick={scrollRightTesti} className="p-3 rounded-full bg-gray-50 border border-gray-200 text-gray-600 hover:bg-[#2e3d2f] hover:text-white transition-all shadow-sm">
                        <ChevronRight className="w-6 h-6" />
                    </button>
                </div>
            </div>

            {/* Testimonial Slider Container */}
            <div 
                ref={testiScrollRef}
                className="flex overflow-x-auto gap-4 md:gap-6 pb-12 pt-2 snap-x snap-mandatory [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
            >
                {testimonials.map((testi) => (
                    <React.Fragment key={`testi-${testi.id}`}>
                        
                        {/* 1. Customer Image Card (Ab ye flex-shrink-0 hai taaki slide ho sake) */}
                        <div className="flex-shrink-0 min-w-[280px] md:min-w-[320px] max-w-[320px] relative rounded-[1.5rem] overflow-hidden h-[380px] shadow-sm group snap-start">
                            <img 
                                src={testi.image} 
                                alt={testi.name} 
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#2e3d2f]/90 via-[#2e3d2f]/20 to-transparent"></div>
                            <h3 className="absolute bottom-6 left-6 text-white font-bold text-xl tracking-wide">
                                {testi.name}
                            </h3>
                        </div>

                        {/* 2. Customer Review Card (Ab ye bhi slide ka hissa hai) */}
                        <div className="flex-shrink-0 min-w-[280px] md:min-w-[320px] max-w-[320px] bg-gray-50 rounded-[1.5rem] p-6 sm:p-8 h-[380px] flex flex-col justify-between shadow-sm border border-gray-100 snap-start">
                            <div>
                                <h3 className="font-bold text-lg text-[#2e3d2f] mb-2">{testi.name}</h3>
                                {/* 5 Star Rating */}
                                <div className="flex gap-1 text-green-600 mb-4">
                                    {[...Array(testi.rating)].map((_, i) => (
                                        <Star key={i} className="w-4 h-4 fill-current" />
                                    ))}
                                </div>
                                <p className="text-gray-600 text-sm leading-relaxed line-clamp-6">
                                    "{testi.review}"
                                </p>
                            </div>

                            {/* Bought Product Tag */}
                            <div className="flex items-center gap-4 bg-white p-3 rounded-xl border border-gray-100 shadow-sm mt-4">
                                <img 
                                    src={testi.productImg} 
                                    alt={testi.productName} 
                                    className="w-12 h-12 rounded-lg object-cover border border-gray-50"
                                />
                                <div className="flex flex-col">
                                    <span className="text-xs font-bold text-[#2e3d2f] line-clamp-1">{testi.productName}</span>
                                    <span className="text-[10px] text-gray-500 font-medium">From {testi.productPrice}</span>
                                </div>
                            </div>
                        </div>

                    </React.Fragment>
                ))}
            </div>
        </div>

      </div>
    </section>
  );
};

export default BlogSection;